var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"circle",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"el-icon-upload2"})])])}
var staticRenderFns = []

export { render, staticRenderFns }